module.exports = __webpack_public_path__ + "images/326034f7d1e1d64cd6ae45f1fbb5cae6.svg";